// @flow
import axios from 'axios';
import { Axios } from 'axios';
import Bugsnag from '@bugsnag/js';

import { getAuthToken, setAuthToken } from '../shared/utils';

class API {
    client: Axios;

    constructor() {
        const baseURL =
            process && process.env && process.env.REACT_APP_API_URL
                ? process.env.REACT_APP_API_URL
                : 'http://localhost:8001';

        const client = axios.create({
            baseURL,
        });

        client.interceptors.request.use(this.checkAuth);

        client.interceptors.response.use(this.handleSuccess, this.handleError);

        this.client = client;
    }

    checkAuth(request: any) {
        const token = getAuthToken();

        if (token && token.length > 0) {
            request.headers.Authorization = `Bearer ${token}`;
        }

        return request;
    }

    handleSuccess(response: any) {
        return response;
    }

    isValidationError = (error: any) => {
        if (!error || !error.response || error.response.status !== 400) {
            return false;
        }
        const data = error.response.data;
        const hasValidation =
            (data && data.validation && typeof data.validation === 'object') ||
            (data && data.errors && typeof data.errors === 'object');
        return !!hasValidation;
    };

    handleError = (error: any) => {
        if (error.response && error.response.status === 401) {
            setAuthToken('');
            window.location.href = window.location.href;
        } else if (Bugsnag.isStarted() && !this.isValidationError(error)) {
            Bugsnag.notify(error, event => {
                event.addMetadata('api', {
                    url: error.config ? error.config.url : undefined,
                    method: error.config ? error.config.method : undefined,
                    status: error.response ? error.response.status : undefined,
                });
            });
        }

        return Promise.reject(error);
    };

    get(path: string) {
        return this.client.get(path);
    }

    patch(path: string, payload: any) {
        return this.client.request({
            method: 'PATCH',
            url: path,
            responseType: 'json',
            data: payload,
        });
    }

    put(path: string, payload: any) {
        return this.client.request({
            method: 'PUT',
            url: path,
            responseType: 'json',
            data: payload,
        });
    }

    post(path: string, payload: any, fullUrl: boolean = false) {
        return this.client.request({
            method: 'POST',
            url: path,
            responseType: 'json',
            data: payload,
        });
    }

    delete(path: string) {
        return this.client.delete(path);
    }
}

const api = new API();

export default api;



// WEBPACK FOOTER //
// ./src/redux/api.js